import React from "react";

import { EditProfile } from "./EditProfile";

import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";

import { dateTimeConstants } from "_constants";
import moment from "moment";
import { preventNegativeValueInDocs, formatDate } from "_helpers/helpers";

const QualificationsComponent = ({
  profileData,
  dropdownData,
  refetchUser,
  isOpen,
  toggleAccordion,
  changeTab,
  permList,
  authUser,
}) => {

  const ownProfile = profileData?.id == authUser?.id;

  return (
    <div
      id="qualifications"
      className={`profile-data__drops profile-data_comp ${isOpen ? "is-active" : ""}`}
    >
      <header onClick={() => toggleAccordion("#qualifications")}>
        <button type="button">
          <h3>Qualifications</h3>
        </button>
      </header>
      <div className="profile-data__drops-cnt">
        <ul>
          <li>
            <span>
              <b>Title</b>
            </span>
            <span>{profileData.user_type}</span>
            <EditProfile
              label="Title"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes("Edit Title")}
            >
              {(register, errors) => (
                <>
                  <label>Title</label>
                  <select
                    {...register("user_type_id", {
                      required: "Title is required",
                    })}
                    defaultValue={profileData.user_type_id}
                    className={
                      errors.user_type_id && "profile-form-field-error"
                    }
                  >
                    <option value="">Select Title</option>
                    {dropdownData.Roles.map((role, index) => (
                      <option key={index} value={role.id}>
                        {role.name}
                      </option>
                    ))}
                  </select>

                  {errors.user_type_id && (
                    <p className="error-message">
                      {errors.user_type_id.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </li>

          <li>
            <span>
              <b>Fire Seasons</b>
            </span>
            <span>{profileData.fire_seasons ?? "-"}</span>
            <EditProfile
              label="Fire Seasons"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={true}
              hasPermissionToEditOthers={permList.includes(
                "Manage Employee Profile Fields",
              )}
            >
              {(register, errors) => (
                <>
                  <label>Fire Seasons</label>
                  <input
                    type="number"
                    {...register("fire_seasons", {
                      min: {
                        value: 0,
                        message: "Fire Seasons must be a valid value",
                      },
                      validate: (value) =>
                        value.toString().length <= 3 ||
                        "Fire Seasons must be at most 3 digits",
                      valueAsNumber: true,
                    })}
                    placeholder="Enter Fire Seasons"
                    defaultValue={profileData.fire_seasons}
                    className={
                      errors.fire_seasons && "profile-form-field-error"
                    }
                    onWheel={(e) => e.target.blur()}
                    onKeyDown={preventNegativeValueInDocs}
                  />
                  {errors.fire_seasons && (
                    <p className="error-message">
                      {errors.fire_seasons.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </li>

          {(permList.includes('Manage Expiry/Assigned Dates') ||
            ownProfile) && (
            <li>
              <span>
                <b>RT-130</b>
              </span>
              <span>{formatDate(profileData.rt_130_expiry)}</span>
              <EditProfile
                label='RT-130'
                profileData={profileData}
                refetchUser={refetchUser}
                authUser={authUser}
                hasPermissionRequiredToEditOwn={false}
                hasPermissionToEditOthers={permList.includes(
                  'Manage Expiry/Assigned Dates',
                )}
              >
                {(register, errors, setValue, control) => (
                  <>
                    <label>RT-130</label>
                    <Controller
                      name='rt_130_expiry'
                      control={control}
                      defaultValue={
                        profileData.rt_130_expiry
                          ? moment(profileData.rt_130_expiry).format(
                              dateTimeConstants.DATE_FORMAT,
                            )
                          : null
                      }
                      rules={{
                        required: 'RT-130 is required',
                      }}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <DatePicker
                          selected={value ? moment(value) : ''}
                          onChange={(date) =>
                            onChange(
                              date &&
                                !date
                                  .endOf('day')
                                  .isAfter(moment().endOf('day'))
                                ? date.format(dateTimeConstants.DATE_FORMAT)
                                : '',
                            )
                          }
                          customInput={<input inputMode='none' />}
                          maxDate={moment()}
                          showMonthDropdown
                          showYearDropdown
                          placeholderText='Select RT 130 Expiry Date'
                          className={error ? 'profile-form-field-error' : ''}
                          dateFormat={dateTimeConstants.DATE_FORMAT}
                          showPopperArrow={false}
                        />
                      )}
                    />
                    {errors.rt_130_expiry && (
                      <p className='error-message'>
                        {errors.rt_130_expiry.message}
                      </p>
                    )}
                  </>
                )}
              </EditProfile>
            </li>
          )}

          <li>
            <span>
              <a
                onClick={() => changeTab("qualifications")}
                className="link-green"
              >
                Qualifications
              </a>
            </span>
            <ul>
              {profileData.qual_key.map((qual, index) => (
                <li>{qual}</li>
              ))}
            </ul>
          </li>

        </ul>
      </div>
    </div>
  );
};

export default QualificationsComponent;
